import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DOMPurify, { Config } from 'dompurify'
import { h } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Sanitize',
  props: {
    html: { default: '' },
    config: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const sanitize = (html: string, config?: Config) => {
  if (config) {
    return DOMPurify.sanitize(html, config)
  }

  return DOMPurify.sanitize(html)
}

const render = () => {
  return h('span', {
    innerHTML: sanitize(props.html, props.config),
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})